import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import LiveVideoContainer from '../menuComponentsContainer/LiveVideoContainer'
import './LiveStreamModal.sass'

const LiveStreamModal = (props) => {
	const { show, deviceId, onHide, title } = props
	const { t } = useTranslation('translation', { keyPrefix: 'homePage.vehicleSidebar' })

	useEffect(() => {
		const previousTitle = document.title
		return () => {
			document.body.classList.remove('live-video-page', 'mobile', 'portrait', 'landscape')
			document.title = previousTitle
		}
	}, [])

	if (!show) return null

	return (
		<Modal
			show
			onHide={onHide}
			dialogClassName="live-stream-modal"
			closeVariant="white"
			centered
		>
			<Modal.Header closeButton>
				<Modal.Title>{title || t('titleLiveStreaming')}</Modal.Title>
			</Modal.Header>
			<Modal.Body className="live-stream-modal-body">
				{deviceId &&
					<LiveVideoContainer key={deviceId} deviceId={deviceId} muted />
				}
			</Modal.Body>
		</Modal>
	)
}

LiveStreamModal.propTypes = {
	show: PropTypes.bool,
	deviceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onHide: PropTypes.func.isRequired,
	title: PropTypes.string,
}

LiveStreamModal.defaultProps = {
	show: false,
	deviceId: null,
	title: '',
}

export default LiveStreamModal
